export function isFinalAnswerActorName(actorName?: string | null): boolean {
  if (typeof actorName !== 'string') return false;
  const normalized = actorName.trim();
  if (!normalized) return false;
  return (
    normalized === 'FinalAnswer' ||
    normalized.endsWith('FinalAnswerAgent') ||
    normalized.endsWith('FinalAnswer') ||
    normalized === 'AnswerDispatchAgent' ||
    normalized === 'ResponsePolisher' ||
    normalized === 'ResponseFinalizer'
  );
}

export function isAnswerChannel(channel?: string | null, actorName?: string | null): boolean {
  if (channel === 'answer') return true;
  if (channel === 'timeline' || channel === 'thinking') return false;
  return isFinalAnswerActorName(actorName);
}

export function isThinkingChannel(channel?: string | null, event?: string | null): boolean {
  if (channel === 'thinking') return true;
  return event === 'thinking';
}

/**
 * Schema-only auto-mode classifiers never own user-visible prose.
 *
 * The AI service suppresses these chunks at the source. Keeping the same
 * contract in the shared renderer also protects clients connected to an older
 * AI image, where feature-prefixed actors such as ``DocxAgentRootClassifier``
 * could leak RouteDecision JSON one token at a time.
 */
export function isInternalRootClassifierMessage(
  event?: string | null,
  actorName?: string | null,
): boolean {
  if (event !== 'message' || typeof actorName !== 'string') return false;
  const normalized = actorName.trim();
  return normalized === 'RootClassifier' || normalized.endsWith('RootClassifier');
}

export function isTimelineChannel(
  channel?: string | null,
  event?: string | null,
  actorName?: string | null,
): boolean {
  if (channel === 'timeline') return true;
  if (channel === 'answer' || channel === 'thinking' || channel === 'widget') return false;
  if (event === 'thinking') return false;
  if (event === 'message' && isFinalAnswerActorName(actorName)) return false;
  return true;
}

export function isWidgetChannel(channel?: string | null, event?: string | null): boolean {
  if (channel === 'widget') return true;
  return event === 'widget_start' || event === 'widget_delta' || event === 'widget_end';
}
